import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronRight, Home } from "lucide-react";
import { subNavMap, topNav } from "../../layout/navConfig";

const injectSubHeaderStyles = () => {
  if (document.getElementById("dynamic-subheader-static-css")) return;

  const style = document.createElement("style");
  style.id = "dynamic-subheader-static-css";
  style.textContent = `
    .erp-subheader-wrap{
      position: sticky;
      top: 72px;
      z-index: 1100;
      margin: 0 !important;
      padding: 0 !important;
      width: 100%;
      background: transparent;
    }

    .erp-subheader-card{
      width: 100%;
      margin: 0 !important;
      padding: 12px 16px !important;
      border-radius: 0 !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      background: var(--app-top-bar, #ffffff);
      color: var(--app-top-bar-text, #152235);
      border-top: 1px solid var(--app-border, #dbe4f0);
      border-bottom: 1px solid var(--app-border, #dbe4f0);
      border-left: none !important;
      border-right: none !important;
      box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
      transition:
        background 0.25s ease,
        color 0.25s ease,
        border-color 0.25s ease;
    }

    .erp-subheader-tabs{
      display: flex;
      flex-wrap: nowrap;
      gap: 10px;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: thin;
      min-width: 0;
      flex: 1 1 auto;
    }

    .erp-sub-tab{
      flex: 0 0 auto;
      border: 1px solid var(--app-border, #dbe4f0);
      background: var(--app-tab, #eef3fb);
      color: var(--app-tab-text, #27405f);
      padding: 10px 14px;
      border-radius: 12px;
      font-weight: 600;
      cursor: pointer;
      white-space: nowrap;
      transition:
        transform 0.18s ease,
        box-shadow 0.18s ease,
        background 0.18s ease,
        border-color 0.18s ease,
        color 0.18s ease;
    }

    .erp-sub-tab:hover{
      color: var(--app-accent, #5b7cff);
      background: var(--app-accent-soft, rgba(91, 124, 255, 0.12));
      border-color: var(--app-accent-border, rgba(91, 124, 255, 0.28));
    }

    .erp-sub-tab.active{
      background: var(--app-tab-active, #5b7cff);
      color: var(--app-tab-active-text, #ffffff);
      border-color: transparent;
      box-shadow: 0 12px 24px var(--app-accent-shadow, rgba(91, 124, 255, 0.2));
    }

    .erp-breadcrumbs{
      flex: 0 0 auto;
      display: inline-flex;
      align-items: center;
      gap: 7px;
      color: var(--app-subtext, #6b7a90);
      font-size: 13px;
      white-space: nowrap;
    }

    .erp-breadcrumbs strong{
      color: var(--app-text, #152235);
    }

    @media (max-width: 900px){
      .erp-subheader-wrap{
        top: 64px;
        margin: 0 !important;
        padding: 0 !important;
      }

      .erp-subheader-card{
        margin: 0 !important;
        padding: 10px 12px !important;
        border-radius: 0 !important;
        flex-direction: column;
        align-items: flex-start;
      }

      .erp-subheader-tabs{
        width: 100%;
      }

      .erp-breadcrumbs{
        width: 100%;
        overflow-x: auto;
      }
    }
  `;
  document.head.appendChild(style);
};

export default function DynamicSubHeader({
  activeTop,
  activeSub,
  setActiveSub,
  validSubs,
}) {
  useEffect(() => {
    injectSubHeaderStyles();
  }, []);

  const items = validSubs || [];
  const topLabel =
    topNav.find((item) => item.key === activeTop)?.label || "Dashboard";

  return (
    <section className="erp-subheader-wrap">
      <div className="erp-subheader-card">
        <div className="erp-subheader-tabs">
          {/* {items.map((item) => (
            <motion.button
              key={item}
              type="button"
              className={`erp-sub-tab ${activeSub === item ? "active" : ""}`}
              onClick={() => setActiveSub(item)}
              whileTap={{ scale: 0.97 }}
              layout
            >
              {item}
            </motion.button>
          ))} */}
          {items.map((item) => (
  <motion.button
    key={item.key} // ✅ unique key
    type="button"
    className={`erp-sub-tab ${activeSub === item.key ? "active" : ""}`}
    onClick={() => setActiveSub(item.key)} // ✅ pass key
    whileTap={{ scale: 0.97 }}
    layout
  >
    {item.label} {/* ✅ show label */}
  </motion.button>
))}
        </div>

        {/* <div className="erp-breadcrumbs">
          <Home size={14} />
          <ChevronRight size={14} />
          <span>{topLabel}</span>
          <ChevronRight size={14} />
          <strong>{activeSub}</strong>
        </div> */}
      </div>
    </section>
  );
}
